module.exports = __webpack_public_path__ + "static/media/SPECIAL.cc690781.png";